import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../../config';
const ProfileDetails = () => {
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    companyName: '',
    numberOfConcerns: '',
    companyMDName: '',
    logo: null,
    // logo: '',
    email: '',
    companyChairmanName: '',
    companyFacebook: '',
    companyLinkedIn: '',
  });

  const [isFormVisible, setIsFormVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const handleFileChange = e => {
  //   setFormData(prevData => ({
  //     ...prevData,
  //     logo: e.target.files[0],
  //   }));
  // };
  const handleFileChange = e => {
    setFormData({
      ...formData,
      logo: e.target.files[0], // Store the File object directly
    });
  };


  // get user info
  const fetchUserProfile = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/account/user-profile/`,
        // 'https://finwise-backend.vercel.app/account/user-profile/',
        // 'https://finwiseback.finwise.com.bd/account/user-profile/',
        // 'http://127.0.0.1:8000/account/user-profile/',
        {
          headers: {
            Cookie:
              'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
          },
          withCredentials: true,
        }
      );
      // console.log("profile details:",response)
      setFormData({
        companyName: response.data.company_name,
        numberOfConcerns: response.data.number_of_concerns,
        companyMDName: response.data.company_md_name,
        email: response.data.email,
        companyChairmanName: response.data.company_chairman_name,
        companyFacebook: response.data.facebook_link || '',
        companyLinkedIn: response.data.linkedin_link || '',
        logo: response.data.company_logo || '',
      });
    } catch (error) {
      console.error('Error fetching user profile:', error);
    }
  };

  // form validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.companyName) {
      newErrors.companyName = 'Company Name is required';
    }

    if (!formData.numberOfConcerns) {
      newErrors.numberOfConcerns = 'Number of Concerns is required';
    }

    if (!formData.companyMDName) {
      newErrors.companyMDName = 'MD Name is required';
    }

    if (!formData.companyChairmanName) {
      newErrors.companyChairmanName = 'Chairman Name is required';
    }

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }

    const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/;
    if (
      formData.companyFacebook &&
      !urlPattern.test(formData.companyFacebook)
    ) {
      newErrors.companyFacebook = 'Invalid Facebook URL';
    }

    if (
      formData.companyLinkedIn &&
      !urlPattern.test(formData.companyLinkedIn)
    ) {
      newErrors.companyLinkedIn = 'Invalid LinkedIn URL';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  // new
  const handleSaveClick = async event => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const formDataToSend = new FormData();
    if (formData.companyName)
      formDataToSend.append('company_name', formData.companyName);
    if (formData.numberOfConcerns)
      formDataToSend.append('number_of_concerns', formData.numberOfConcerns);
    if (formData.companyChairmanName)
      formDataToSend.append(
        'company_chairman_name',
        formData.companyChairmanName
      );
    if (formData.companyMDName)
      formDataToSend.append('company_md_name', formData.companyMDName);
    if (formData.email) formDataToSend.append('email', formData.email);
    if (formData.companyFacebook)
      formDataToSend.append('facebook_link', formData.companyFacebook || '');
    if (formData.companyLinkedIn)
      formDataToSend.append('linkedin_link', formData.companyLinkedIn || '');

    // Only append if it's a valid File object
    if (formData.logo instanceof File) {
      formDataToSend.append('company_logo', null);
    }
    // if (formData.logo instanceof File) {
    //   formDataToSend.append('company_logo', formData.logo, formData.logo.name);
    // }

    try {
      const response = await axios.put(
        // 'http://127.0.0.1:8000/account/edit-profile/',
        `${API_BASE_URL}/account/edit-profile/`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Cookie:
              'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
          },
          withCredentials: true,
        }
      );

      Swal.fire({
        title: 'Success!',
        text: 'Profile updated successfully.',
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
      await fetchUserProfile();
      navigate('/dashboard');
    } catch (error) {
      console.error('Error updating profile:', error.response.data);
      Swal.fire({
        title: 'Error!',
        // text: 'Please try again.',
        text: error.response.data.email,
        customClass: {
          popup: 'w-72 h-auto p-3',
          title: 'text-lg',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
        },
      });
    }
  };

  // const handleSaveClick = async event => {
  //   event.preventDefault();

  //   if (!validateForm()) {
  //     // If form is invalid, stop the submission
  //     return;
  //   }

  //   const formDataToSend = new FormData();
  //   if (formData.companyName)
  //     formDataToSend.append('company_name', formData.companyName);
  //   if (formData.numberOfConcerns)
  //     formDataToSend.append('number_of_concerns', formData.numberOfConcerns);
  //   if (formData.companyChairmanName)
  //     formDataToSend.append(
  //       'company_chairman_name',
  //       formData.companyChairmanName
  //     );
  //   if (formData.companyMDName)
  //     formDataToSend.append('company_md_name', formData.companyMDName);
  //   if (formData.email) formDataToSend.append('email', formData.email);
  //   if (formData.companyFacebook)
  //     formDataToSend.append('facebook_link', formData.companyFacebook ||'');
  //   if (formData.companyLinkedIn)
  //     formDataToSend.append('linkedin_link', formData.companyLinkedIn || '');

  //   // if (formData.logo) formDataToSend.append('company_logo', formData.logo);

  //     if (formData.logo) {
  //       formDataToSend.append(
  //         'company_logo',
  //         formData.logo,
  //         formData.logo.name
  //       );
  //     }

  //   console.log('FormData before submit:', formData);

  //   try {
  //     const response = await axios.put(
  //       // 'https://finwise-backend.vercel.app/account/edit-profile/',
  //       // 'https://finwiseback.finwise.com.bd/account/edit-profile/',
  //       'http://127.0.0.1:8000/account/edit-profile/',
  //       formDataToSend,
  //       {
  //         headers: {
  //           'Content-Type': 'multipart/form-data',
  //           Cookie:
  //             'csrftoken=EPrb01eS9RiPV0VBupNxOOgmKdxkDQZB; sessionid=cpsfimbce8mh9ckefwxa9q1i3v65tqtr',
  //         },
  //         withCredentials: true,
  //       }
  //     );

  //     // console.log('Loan application response:', response.data);
  //     Swal.fire({
  //       title: 'Success!',
  //       text: 'Profile updated succesfully.',
  //       customClass: {
  //         popup: 'w-72 h-auto p-3',
  //         title: 'text-lg',
  //         content: 'text-xs',
  //         confirmButton: 'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
  //       },
  //     });
  //     await fetchUserProfile();
  //     navigate('/dashboard');
  //   } catch (error) {
  //     console.error('Error updating profile:', error.response.data);
  //       Swal.fire({
  //         title: 'Error!',
  //         text: 'Please try again.',
  //         customClass: {
  //           popup: 'w-72 h-auto p-3',
  //           title: 'text-lg',
  //           content: 'text-xs',
  //           confirmButton:
  //             'bg-headerBtn text-white px-4 py-1 text-sm rounded-md',
  //         },
  //       });
  //   }
  // };


  const handleCloseProfile = () => {
    setIsFormVisible(false);
    navigate('/dashboard');
  };

  return (
    <>
      {isFormVisible && (
        <div className="md:px-10 px-2 md:py-10 py-6">
          <div className="bg-headerBtn rounded-t-lg md:w-full p-2 md:pl-8 text-left">
            <h2 className="md:text-2xl text-lg text-white font-bold md:mb-2">
              Profile Details
            </h2>
            <p className="md:text-sm text-xs text-gray-50">
              COMPANY DETAILS INFORMATION
            </p>
          </div>

          <div className="bg-AboutUsBg md:text-sm text-xs flex flex-col items-center md:py-10 py-4 px-4 md:px-0 xl:h-screen">
            <form
              className="w-full flex flex-col md:flex-row max-w-7xl md:gap-10 gap-2 justify-center"
              onSubmit={handleSaveClick}
            >
              <div className="space-y-4">
                {/* Input Fields */}
                {[
                  'companyName',
                  'numberOfConcerns',
                  'companyMDName',
                  'companyChairmanName',
                ].map(field => (
                  <div
                    key={field}
                    className="md:items-center md:gap-4 space-y-1"
                  >
                    <label
                      htmlFor={field}
                      className="block font-medium text-gray-700"
                    >
                      {field
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/^./, str => str.toUpperCase())}{' '}
                      <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      id={field}
                      name={field}
                      value={formData[field]}
                      onChange={handleInputChange}
                      placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1')}`}
                      className="md:w-96 w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                    />
                    {errors[field] && (
                      <p className="text-red-600 text-sm">{errors[field]}</p>
                    )}
                  </div>
                ))}
              </div>

              <div className="md:mt-0 mt-2 space-y-4">
                {/* File and URL Fields */}
                <div className="md:items-center md:gap-4 space-y-1">
                  <div className="flex items-center">
                    <label
                      htmlFor="company_logo"
                      className="block font-medium text-gray-700"
                    >
                      Logo <span className="text-red-600">*</span>
                    </label>
                    {/* <div className="flex gap-2 items-center">
                      <p className="mt-1 md:text-sm text-xs text-gray-600">
                        <span className="">
                          Previous logo:
                        </span>{' '}
                      </p>
                      {formData?.logo && (
                        <img
                          src={
                            formData?.logo
                              ? `http://127.0.0.1:8000${formData.logo}`
                              : ''
                          }
                          alt="logo"
                          className="rounded w-10 h-auto object-cover mt-2"
                        />
                      )}
                    </div> */}
                  </div>
                  <input
                    type="file"
                    id="company_logo"
                    name="logo"
                    // onChange={handleFileChange}
                    // value={formData.logo}
                    className="md:w-96 w-full p-2 bg-white  border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                    // required
                  />
                  <p className="hidden">
                    {formData.logo ? formData.logo.name : 'No file selected'}
                  </p>
                </div>
                {['email', 'companyFacebook', 'companyLinkedIn'].map(field => (
                  <div
                    key={field}
                    className="md:items-center md:gap-4 space-y-1"
                  >
                    <label
                      htmlFor={field}
                      className="block font-medium text-gray-700"
                    >
                      {field
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/^./, str => str.toUpperCase())}
                      {field === 'email' && (
                        <span className="text-red-600"> *</span>
                      )}
                    </label>
                    <input
                      type={field === 'email' ? 'email' : 'url'}
                      id={field}
                      name={field}
                      value={formData[field]}
                      onChange={handleInputChange}
                      placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1')}`}
                      className="md:w-96 w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                      required={field === 'email'} // Adds required attribute only for email
                    />
                    {errors[field] && (
                      <p className="text-red-600 text-sm">{errors[field]}</p>
                    )}
                  </div>
                ))}

                {/* {['email', 'companyFacebook', 'companyLinkedIn'].map(field => (
                  <div
                    key={field}
                    className="md:items-center md:gap-4 space-y-1"
                  >
                    <label
                      htmlFor={field}
                      className="block font-medium text-gray-700"
                    >
                      {field
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/^./, str => str.toUpperCase())}
                    </label>
                    <input
                      type={field === 'email' ? 'email' : 'url'}
                      id={field}
                      name={field}
                      value={formData[field]}
                      onChange={handleInputChange}
                      placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1')}`}
                      className="md:w-96 w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                    />
                    {errors[field] && (
                      <p className="text-red-600 text-sm">{errors[field]}</p>
                    )}
                  </div>
                ))} */}
              </div>
            </form>

            {/* Save and Cancel Buttons */}
            <div className="flex justify-center space-x-4 mt-6">
              <button
                onClick={handleSaveClick}
                type="submit"
                className="bg-headerBtn text-white md:py-2 py-1 md:px-8 px-4 text-xs md:text-sm rounded-xl hover:bg-btnHover"
              >
                Save
              </button>
              <button
                onClick={handleCloseProfile}
                type="button"
                className="border-headerBtn border-2 text-headerBtn text-xs md:text-sm md:py-2 py-1 md:px-6 px-4 rounded-xl hover:bg-btnHover hover:text-white"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileDetails;

// <form
//   className="w-full flex flex-col md:flex-row max-w-7xl md:gap-10 gap-2 justify-center"
//   onSubmit={handleSaveClick}
// >
//   <div className="space-y-4">
//     {/* Input Fields */}
//     {[
//       'companyName',
//       'numberOfConcerns',
//       'companyMDName',
//       'companyChairmanName',
//     ].map(field => (
//       <div key={field} className="md:items-center md:gap-4 space-y-1">
//         <label htmlFor={field} className="block font-medium text-gray-700">
//           {field
//             .replace(/([A-Z])/g, ' $1')
//             .replace(/^./, str => str.toUpperCase())}{' '}
//           <span className="text-red-600">*</span>
//         </label>
//         <input
//           type="text"
//           id={field}
//           name={field}
//           value={formData[field]}
//           onChange={handleInputChange}
//           placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1')}`}
//           className="md:w-96 w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//         />
//       </div>
//     ))}
//   </div>

//   <div className="md:mt-0 mt-2 space-y-4">
//     {/* File and URL Fields */}
//     <div className="md:items-center md:gap-4 space-y-1">
//       <label htmlFor="logo" className="block font-medium text-gray-700">
//         Logo
//       </label>
//       <input
//         type="file"
//         id="logo"
//         name="logo"
//         onChange={handleFileChange}
//         className="md:w-96 w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//       />
//     </div>

//     {['email', 'companyFacebook', 'companyLinkedIn'].map(field => (
//       <div key={field} className="md:items-center md:gap-4 space-y-1">
//         <label htmlFor={field} className="block font-medium text-gray-700">
//           {field
//             .replace(/([A-Z])/g, ' $1')
//             .replace(/^./, str => str.toUpperCase())}
//         </label>
//         <input
//           type={field === 'email' ? 'email' : 'url'}
//           id={field}
//           name={field}
//           value={formData[field]}
//           onChange={handleInputChange}
//           placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1')}`}
//           className="md:w-96 w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring focus:ring-opacity-50"
//         />
//       </div>
//     ))}
//   </div>
// </form>;
